import { Text, View } from "@react-pdf/renderer";
import { parseDate } from "helpers/date";
import { parsePrice, centsToDollars } from "helpers/price";
import { useMemo } from "react";

function ProviderCard({
  item,
  styles,
  showLastPaymentAmount,
}: {
  item: any;
  styles: any;
  showLastPaymentAmount: boolean;
}) {
  const finalBalanceToShow = useMemo(() => {
    // in case order was fully paid without payment plan, we show the final balance
    if (!showLastPaymentAmount) {
      return item.finalBalance;
    }
    // in case order was paid with payment plan and for this provider the remaining amount is 0, we show the final balance
    if (item.clearDiscountedPriceFull - item.totalAmountPaid <= 0) {
      return item.finalBalance;
    }
    // in case there is still remaining amount for the provider, we show the total amount to be paid to the provider
    return item.clearDiscountedPriceFull;
  }, [item]);
  return (
    <View
      wrap={false}
      minPresenceAhead={120}
      style={{
        ...styles.section,
        marginBottom: "0px",
        marginTop: "10px",
      }}
    >
      <Text style={{ ...styles.titleSmall, marginBottom: "5px" }}>
        {item?.providerName}
      </Text>
      {showLastPaymentAmount && (
        <View style={{ ...styles.paymentItem, marginBottom: "5px" }}>
          <Text style={styles.text}>
            Last Payment on: {parseDate(item.lastPaymentDate, false, true)}
          </Text>
          <Text style={styles.text}>
            {parsePrice(centsToDollars(item.lastPaymentAmount))}
          </Text>
        </View>
      )}
      <View style={{ ...styles.paymentItem, marginBottom: "5px" }}>
        <Text style={styles.text}>Total Paid:</Text>
        <Text style={styles.text}>
          {parsePrice(centsToDollars(item.totalAmountPaid))}
        </Text>
      </View>
      <View style={{ ...styles.paymentItem, marginBottom: "5px" }}>
        <Text style={styles.text}>Refunds/Transfers:</Text>
        <Text style={styles.text}>
          {parsePrice(centsToDollars(item.transfers))}
        </Text>
      </View>
      <View style={styles.divider} />
      <View style={{ ...styles.paymentItem, marginBottom: "0px" }}>
        <Text style={{ ...styles.text, color: "#0D0D0D" }}>Final Balance:</Text>
        <Text style={{ ...styles.text, color: "#0D0D0D" }}>
          {parsePrice(centsToDollars(finalBalanceToShow))}
        </Text>
      </View>
    </View>
  );
}

export function BreakDownSection({
  styles,
  breakDownInfo,
  showLastPaymentAmount,
}: {
  styles: any;
  breakDownInfo: any;
  showLastPaymentAmount: boolean;
}) {
  const [first, ...rest] = breakDownInfo;
  return (
    <View style={styles.section} wrap>
      <View wrap={false}>
        <Text style={styles.title}>Payment Breakdown by Provider</Text>
        <ProviderCard
          item={first}
          styles={styles}
          showLastPaymentAmount={showLastPaymentAmount}
        />
      </View>
      {rest.map((item: any, i: number) => (
        <ProviderCard
          item={item}
          styles={styles}
          key={i}
          showLastPaymentAmount={showLastPaymentAmount}
        />
      ))}
    </View>
  );
}
